/** Matches backend Setting::DEFAULT_CURRENCY */
export const DEFAULT_CURRENCY = 'EGP';

/**
 * Resolve display currency for money amounts.
 * Prefer entity/API currency (works for dentists who cannot load vendor settings).
 */
export const resolveDisplayCurrency = (...candidates) => {
    for (const candidate of candidates) {
        if (candidate == null) continue;
        const trimmed = String(candidate).trim();
        if (trimmed) return trimmed.toUpperCase();
    }
    return DEFAULT_CURRENCY;
};

export default resolveDisplayCurrency;
